export default __webpack_public_path__ + "static/media/42.f88a8445.png";